export default "__VITE_ASSET__87c582f4__"